import { Provider } from 'react-redux';
import store from './redux/store/store';
import Main from './Main';
import ScrollToTop from './styling/ScrollToTop';
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { HelmetProvider } from 'react-helmet-async';

function App() {
  
  let persistentStore = persistStore(store);
  const helmetContext= {}

  return (
    <HelmetProvider context={helmetContext}>
      <Provider store={store}>
        <PersistGate loading={<div />} persistor={persistentStore}>
          <ScrollToTop />
            <div className="App">
              <header className="App-header">
                <Main />
              </header>
            </div>
          </PersistGate>
      </Provider>
    </HelmetProvider>
  );
}

export default App;
